import { UserCircleIcon, KeyIcon } from '@heroicons/react/24/outline';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from '../features/auth/authSlice';
import { ChangePasswordForm } from '../components/ChangePasswordForm';

export const PerfilPage = () => {
  const currentUser = useSelector(selectCurrentUser);

  return (
    <div className='space-y-6'>
      <h1 className='text-2xl font-bold text-foreground'>Mi Perfil</h1>

      <div className='bg-card text-card-foreground p-6 rounded-lg shadow-sm border border-border space-y-4'>
        <div className='flex items-center gap-2 text-lg font-medium text-foreground'>
          <UserCircleIcon className='h-5 w-5 text-muted-foreground' />
          <span>Información</span>
        </div>
        <div className='space-y-3'>
          <div>
            <div className='text-sm text-muted-foreground'>Email</div>
            <div className='text-sm text-foreground font-medium'>{currentUser?.email || '-'}</div>
          </div>
          <div>
            <div className='text-sm text-muted-foreground'>Rol</div>
            <div className='text-sm text-foreground font-medium'>{currentUser?.role || '-'}</div>
          </div>
        </div>
      </div>

      <div className='bg-card text-card-foreground p-6 rounded-lg shadow-sm border border-border space-y-4'>
        <div className='flex items-center gap-2 text-lg font-medium text-foreground'>
          <KeyIcon className='h-5 w-5 text-muted-foreground' />
          <span>Cambiar contraseña</span>
        </div>
        <ChangePasswordForm />
      </div>
    </div>
  );
};
